import React, { useState } from "react";

const FileInput = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    error,
    baseinfo,
    defaultValue,
  } = props;

  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div className={`my-4 ${containerCls}`}>
      {label ? <div className="pb-1 text-gray-800">{label}</div> : null}

      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full ${
          error ? "" : ""
        }`}
        {...inputProps}
      />
      {baseinfo ? <div className="pb-1 text-gray-800">{baseinfo}</div> : null}
      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default FileInput;
